<div class="b-step" [ngClass]="{
         'b-step--is-collapsible': collapsible,
         'b-step--is-collapsed': collapsed
       }">

  <header *ngIf="title" class="b-step__heading b-step__heading-update" [ngClass]="{
    'b-content-close': isClose
  }">

    <ng-template #titleContent>
      @if (collapsible) {
        <button type="button" class="b-heading-toggle" [attr.aria-expanded]="!collapsed" (click)="collapsed = !collapsed">
          <ng-container *ngTemplateOutlet="stepName"></ng-container>
          <span class="b-icon b-icon--hinge-fold-out" aria-hidden="true">{{toggleMatIcon}}</span>
        </button>
      } @else {
        <ng-container *ngTemplateOutlet="stepName"></ng-container>
      }
    </ng-template>
    <ng-template #stepName>
      <span class="b-step__step-name" [ngClass]="{
               'b-step__no-shortcut': !stepTitleShortcut,
               'b-step--is-collapsed': collapsed
             }" [innerHTML]="title"></span>
    </ng-template>
    @switch (level) {
      @case (1) { <h1 class="b-step__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h1> }
      @case (2) { <h2 class="b-step__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h2> }
      @case (4) { <h4 class="b-step__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h4> }
      @case (5) { <h5 class="b-step__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h5> }
      @case (6) { <h6 class="b-step__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h6> }
      @default { <h3 class="b-step__title"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h3> }
    }

    <div class="b-step__issue-trigger">
      <ng-content select="f-facet[name=step-issues-trigger],[facet-step-issues-trigger]"></ng-content>
    </div>

  </header>
  <!-- Step Issues Block visible always -->
  <div class="b-step__content" [ngStyle]="contentStyle">
    <ng-content select="f-facet[name=step-issues-block],[facet-step-issues-block]"></ng-content>
    <ng-container *ngIf="!collapsed">
      <div class="b-step__info" [hideEmpty]="1">
        <ng-content select="f-facet[name=step-info],[facet-step-info]"></ng-content>
      </div>
      <div class="b-step__content-top" [hideEmpty]="1">
        <ng-content select="f-facet[name=step-content-top],[facet-step-content-top]"></ng-content>
      </div>
      <div *ngIf="reviewMode" class="b-step__actions" [hideEmpty]="1">
        <ng-content select="f-facet[name=step-actions],[facet-step-actions]"></ng-content>
      </div>
      <div class="b-step__content-bottom" [hideEmpty]="1">
        <ng-content select="f-facet[name=step-content-bottom],[facet-step-content-bottom]"></ng-content>
      </div>
    </ng-container>
  </div>

</div>